<ng-container>
  <div class="signing-details">
    @if(!shouldShowSessionHandoff()) {
    <h1>Welcome to your signing!</h1>
    }
    <app-signing-details-card *appMobileOnly></app-signing-details-card>
  </div>

  @if (isSigningAgent()) {
  <app-signing-agent-welcome-page></app-signing-agent-welcome-page>
  } @else if (shouldShowSessionHandoff()) {
  <app-session-handoff-page></app-session-handoff-page>
  } @else {
  <app-non-signing-agent-welcome-page>
    <app-alert-banner-expand
      (buttonAction)="copyLink()"
      [buttonName]="alertBannerButtonText"
      [header]="alertBannerHeader"
      [isDisabled]="isAlertButtonDisabled"
      [isExpanded]="isNotMobile()"
      [type]="type"
      class="alert-banner"
    >
      <p class="alert-banner__message">
        They can join this session on the same device or use the link below to sign in on their own
        device.
      </p>

      <div>
        <p class="alert-banner__subtitle">What to do:</p>

        <ol class="alert-banner__instructions">
          <li>
            Copy the link below and send it to the NBTH if they'll be joining on their own device.
          </li>
          <li>Once the link is shared, continue with your signing session on this device.</li>
        </ol>
      </div>
    </app-alert-banner-expand>
  </app-non-signing-agent-welcome-page>
  }
</ng-container>
<app-package-status-monitor></app-package-status-monitor>
